<template>
<v-container fluid>
        <header-datasheets-overview
          v-bind:classification="this.classification"
          v-bind:category="this.category">
        <datasheets-table
          v-bind:datasheets="datasheets">
        </datasheets-table>
        </header-datasheets-overview>
</v-container>
</template>

<script>
import HeaderDatasheetsOverview from '../components/HeaderDatasheetsOverview.vue';
import DatasheetsTable from '../components/DatasheetsTable.vue';

export default {
  components: { DatasheetsTable, HeaderDatasheetsOverview },
  name: 'DatasheetsOverview',

  props: ['classification', 'category', 'datasheets'],
};
</script>

<style scoped>
</style>
